<template>
  <div id="app" class="position-relative"
       :class="campaignClass">
    <router-view name="header"></router-view>
    <router-view></router-view>
    <cookies-component></cookies-component>
    <footer-component></footer-component>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import CookiesComponent from "./components/cookies-component";
import FooterComponent from "@/components/footer-component";

const currentYearFull = new Date().getFullYear();

export default {
  name: 'App',
  components: {
    FooterComponent,
    CookiesComponent,
  },
  computed: {
    ...mapGetters({
      campaignClass: 'campaignClass'
    })
  },
  data() {
    return {
      may24th: {
        startDate: new Date(`05/22/${currentYearFull}`),
        endDate: new Date(`06/01/${currentYearFull}`)
      },
      september6th: {
        startDate: new Date(`09/06/${currentYearFull}`),
        endDate: new Date(`09/14/${currentYearFull}`)
      },
      september15th: {
        startDate: new Date(`09/15/${currentYearFull}`),
        endDate: new Date(`09/21/${currentYearFull}`)
      },
      september22th: {
        startDate: new Date(`09/22/${currentYearFull}`),
        endDate: new Date(`09/29/${currentYearFull}`)
      },
      november1st: {
        startDate: new Date(`11/01/${currentYearFull}`),
        endDate: new Date(`11/07/${currentYearFull}`)
      },
      christmas24st: {
        startDate: new Date(`12/24/${currentYearFull}`),
        endDate: new Date(`12/30/${currentYearFull}`)
      },
      newYear31st: {
        startDate: new Date(`12/31/${currentYearFull}`),
        endDate: new Date(`01/08/${currentYearFull + 1}`)
      },
      march3th: {
        startDate: new Date(`03/03/${currentYearFull}`),
        endDate: new Date(`03/08/${currentYearFull}`)
      },
    }
  },
  beforeMount() {
    if (this.inDateRange(this.may24th)) {
      this.$store.commit('changeCampaignClass', 'may24th');
    } else if (this.inDateRange(this.september6th)) {
      this.$store.commit('changeCampaignClass', 'september6th');
    } else if (this.inDateRange(this.september15th)) {
      this.$store.commit('changeCampaignClass', 'september15th');
    } else if (this.inDateRange(this.september22th)) {
      this.$store.commit('changeCampaignClass', 'september22th');
    } else if (this.inDateRange(this.november1st)) {
      this.$store.commit('changeCampaignClass', 'november1st');
    } else if (this.inDateRange(this.christmas24st)) {
      this.$store.commit('changeCampaignClass', 'christmas24st');
    } else if (this.inDateRange(this.newYear31st)) {
      this.$store.commit('changeCampaignClass', 'newYear31st');
    } else if (this.inDateRange(this.march3th)) {
      this.$store.commit('changeCampaignClass', 'march3th');
    } else {
      this.$store.commit('changeCampaignClass', 'no-campaign');
    }
  },
  methods: {
    inDateRange(dateRange) {
      let today = new Date();
      if (today.getMonth() === 0) {
        today.setFullYear(today.getFullYear() + 1);
      }
      return today >= dateRange.startDate && today <= dateRange.endDate;
    }
  }
}
</script>

<style>
</style>
